module.exports = vendor_cc0e48561e6c85b38c87;